export default "__VITE_ASSET__CeRtmmyY__"